import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ProgressLoadingComponent } from './progress-loading/progress-loading.component';
import { TutorialComponent } from './tutorial/tutorial.component';
import { StoreListComponent } from './store-list/store-list.component';
import { TicketsDetailComponent } from './tickets-detail/tickets-detail.component';
import { PrintTicketComponent } from './print-ticket/print-ticket.component';
import { ContestModalComponent } from './contest-modal/contest-modal.component';
import { ComponentsModule } from '../components/components.module';

@NgModule({
  declarations: [
    ProgressLoadingComponent,
    TutorialComponent,
    StoreListComponent,
    TicketsDetailComponent,
    PrintTicketComponent,
    ContestModalComponent,
  ],
  exports: [
    ProgressLoadingComponent,
    TutorialComponent,
    StoreListComponent,
    TicketsDetailComponent,
    PrintTicketComponent,
    ContestModalComponent,
  ],
  imports: [
    CommonModule,
    IonicModule,
    FormsModule,
    ReactiveFormsModule,
    ComponentsModule,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class ModalsModule {}
